export default __webpack_public_path__ + "static/media/Space_01.55308d6a.png";